import Pricing from "../components/Pricing";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Services.css";
import { ENDPOINTS } from "../api/api";
import useFetch from "../hooks/useFetch";
import { useTranslation } from "react-i18next";
import "../i18n";

/* ── Service pictorials — unique per service index ── */
const ServiceVisual = ({ index }) => {
  if (index === 0) return (
    <div className="sv-visual sv-visual--browser">
      <div className="sv-vis-browser">
        <div className="sv-vis-bar">
          <span className="sv-dot sv-dot-r"></span>
          <span className="sv-dot sv-dot-y"></span>
          <span className="sv-dot sv-dot-g"></span>
          <span className="sv-vis-url"></span>
        </div>
        <div className="sv-vis-code">
          <div className="sv-cl"><span className="sv-ln">1</span><span className="sv-kw">import</span><span className="sv-op"> React </span><span className="sv-kw">from</span><span className="sv-str"> 'react'</span></div>
          <div className="sv-cl"><span className="sv-ln">2</span><span className="sv-kw">const</span> <span className="sv-fn">App</span><span className="sv-op"> = () =&gt; {"{"}</span></div>
          <div className="sv-cl"><span className="sv-ln">3</span><span className="sv-op">&nbsp;&nbsp;return </span><span className="sv-str">&lt;Dashboard /&gt;</span></div>
          <div className="sv-cl"><span className="sv-ln">4</span><span className="sv-op">{"}"}</span></div>
          <div className="sv-cl"><span className="sv-ln">5</span><span className="sv-kw">export default</span><span className="sv-op"> App</span></div>
        </div>
      </div>
    </div>
  );

  if (index === 1) return (
    <div className="sv-visual sv-visual--mobile">
      <div className="sv-phone-wrap">
        <div className="sv-phone sv-phone--main">
          <div className="sv-phone-notch"></div>
          <div className="sv-phone-screen">
            <div className="sv-phone-row sv-phone-row--gold"></div>
            <div className="sv-phone-row"></div>
            <div className="sv-phone-row sv-phone-row--short"></div>
            <div className="sv-phone-btn"></div>
            <div className="sv-phone-row" style={{marginTop:"6px"}}></div>
            <div className="sv-phone-row sv-phone-row--short"></div>
          </div>
          <div className="sv-phone-home"></div>
        </div>
        <div className="sv-phone sv-phone--ghost">
          <div className="sv-phone-notch"></div>
          <div className="sv-phone-screen">
            <div className="sv-phone-row sv-phone-row--gold"></div>
            <div className="sv-phone-row"></div>
          </div>
          <div className="sv-phone-home"></div>
        </div>
      </div>
    </div>
  );

  if (index === 2) return (
    <div className="sv-visual sv-visual--radar">
      <div className="sv-radar">
        <div className="sv-radar-ring sv-radar-ring--1"></div>
        <div className="sv-radar-ring sv-radar-ring--2"></div>
        <div className="sv-radar-ring sv-radar-ring--3"></div>
        <div className="sv-radar-sweep"></div>
        <div className="sv-radar-dot" style={{top:"22%",left:"58%"}}></div>
        <div className="sv-radar-dot" style={{top:"60%",left:"25%"}}></div>
        <div className="sv-radar-dot" style={{top:"70%",left:"65%"}}></div>
        <div className="sv-radar-center"></div>
      </div>
    </div>
  );

  if (index === 3) return (
    <div className="sv-visual sv-visual--terminal">
      <div className="sv-terminal">
        <div className="sv-terminal-bar">
          <span className="sv-dot sv-dot-r"></span>
          <span className="sv-dot sv-dot-y"></span>
          <span className="sv-dot sv-dot-g"></span>
          <span className="sv-terminal-title">bash — solviotech</span>
        </div>
        <div className="sv-terminal-body">
          <div className="sv-tl sv-tl--cmd">$ npm run deploy</div>
          <div className="sv-tl">▸ Building production bundle...</div>
          <div className="sv-tl">▸ Pushing to VPS 203.161.38.x</div>
          <div className="sv-tl sv-tl--dim">▸ Restarting gunicorn service</div>
          <div className="sv-tl">✓ Deployed <span className="sv-cursor"></span></div>
        </div>
      </div>
    </div>
  );

  if (index === 4) return (
    <div className="sv-visual sv-visual--design">
      <div className="sv-design-wrap">
        <div className="sv-wireframe">
          <div className="sv-wf-topbar">
            <div className="sv-wf-tab sv-wf-tab--active"></div>
            <div className="sv-wf-tab"></div>
            <div className="sv-wf-tab"></div>
          </div>
          <div className="sv-wf-hero"></div>
          <div className="sv-wf-row sv-wf-row--w80"></div>
          <div className="sv-wf-row sv-wf-row--w60"></div>
          <div className="sv-wf-btn"></div>
        </div>
        <div className="sv-palette">
          <div className="sv-swatch" style={{background:"#020f09",border:"1px solid rgba(195,185,150,0.3)"}}></div>
          <div className="sv-swatch" style={{background:"#c3b996"}}></div>
          <div className="sv-swatch" style={{background:"#0a6b5a"}}></div>
          <div className="sv-swatch" style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.1)"}}></div>
          <div className="sv-swatch" style={{background:"#061209"}}></div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="sv-visual sv-visual--flow">
      <div className="sv-flow">
        <div className="sv-flow-node sv-flow-node--active">Discovery</div>
        <div className="sv-flow-arrow">↓</div>
        <div className="sv-flow-node sv-flow-node--active">Architecture</div>
        <div className="sv-flow-arrow">↓</div>
        <div className="sv-flow-node">Implementation</div>
        <div className="sv-flow-arrow">↓</div>
        <div className="sv-flow-node">Delivery</div>
      </div>
    </div>
  );
};

/* ── Main component ── */
const Services = () => {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "en").split("-")[0].toLowerCase();
  const { data: services, loading: loadingServices } = useFetch(`${ENDPOINTS.serviceOfferings}?lang=${lang}`);
  const [activeIdx, setActiveIdx] = useState(0);

  const SERVICE_EXTRAS = {
    "Web Development":          { tag: "Core Service",   features: [{ name: "Web Applications",      sub: "Full-stack React + Flask apps with PostgreSQL" }, { name: "REST APIs",               sub: "Secure, documented, rate-limited endpoints" }, { name: "Database Architecture",   sub: "PostgreSQL schema design & migrations" }, { name: "Code Review & Audits",    sub: "Performance & security reviews" }] },
    "Mobile App Development":   { tag: "Popular",        features: [{ name: "React Native",           sub: "Cross-platform iOS & Android apps" }, { name: "Offline-First Design",    sub: "Works even without internet connection" }, { name: "Push Notifications",      sub: "Real-time alerts and updates" }, { name: "App Store Deployment",    sub: "Full submission and listing support" }] },
    "AI & Intelligent Systems": { tag: "Cutting Edge",   features: [{ name: "Chatbot Development",   sub: "Keyword & ML-powered conversational bots" }, { name: "ML Integration",          sub: "Predictions and recommendations" }, { name: "Data Pipelines",          sub: "ETL systems and analytics flows" }, { name: "NLP Solutions",           sub: "Text analysis and classification" }] },
    "Cloud & DevOps":           { tag: "Infrastructure", features: [{ name: "AWS / GCP / Azure",      sub: "Multi-cloud deployment and management" }, { name: "CI/CD Pipelines",         sub: "Automated build, test, and deploy" }, { name: "Docker & Kubernetes",     sub: "Container orchestration at scale" }, { name: "Monitoring & Alerts",     sub: "Uptime tracking and incident response" }] },
    "UI/UX Design":             { tag: "Design",         features: [{ name: "Wireframing",            sub: "Low-fi and hi-fi layout prototypes" }, { name: "Figma Prototypes",        sub: "Clickable, testable design files" }, { name: "Design Systems",          sub: "Component libraries and style guides" }, { name: "Usability Testing",       sub: "User research and feedback loops" }] },
    "Tech Consulting":          { tag: "Advisory",       features: [{ name: "Tech Stack Audits",      sub: "Code quality and architecture reviews" }, { name: "System Architecture",     sub: "Scalable design for your product" }, { name: "Roadmap Planning",        sub: "Prioritised build plan with milestones" }, { name: "Team Training",           sub: "Workshops and pair programming sessions" }] },
  };

  const STATS = [
    { value: "50+", label: "Projects Delivered" },
    { value: "98%", label: "Client Satisfaction" },
    { value: "6+",  label: "Service Domains" },
    { value: "3+",  label: "Years of Experience" },
  ];

  const SERVICES = (services || []).map((s) => ({
    ...s,
    tag: SERVICE_EXTRAS[s.name]?.tag || "Service",
    features: SERVICE_EXTRAS[s.name]?.features || [],
  }));

  const active = SERVICES[activeIdx];

  return (
    <div className="services-page">

      {/* ── HERO ── */}
      <section className="services-hero">
        <div className="services-hero-bg">
          <div className="sv-orb sv-orb--1"></div>
          <div className="sv-orb sv-orb--2"></div>
          <div className="sv-hero-grid"></div>
        </div>
        <div className="services-hero-content">
          <span className="services-eyebrow">
            <i className="fa-solid fa-layer-group"></i> {t("services.eyebrow")}
          </span>
          <h1 className="services-hero-title">
            Solutions Built for<span className="services-hero-highlight"> Real Impact</span>
          </h1>
          <p className="services-hero-subtitle">
            From idea to deployment — we craft technology that solves real problems,
            scales with your growth, and keeps Africa moving forward.
          </p>
          <div className="services-hero-actions">
            <NavLink to="/contact" className="btn-primary">
              <i className="fa-solid fa-bolt"></i> Start a Project
            </NavLink>
            <NavLink to="/portfolio" className="btn-secondary">
              View Our Work <i className="fa-solid fa-arrow-right"></i>
            </NavLink>
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="services-stats">
        {STATS.map((stat) => (
          <div key={stat.label} className="sv-stat-item">
            <span className="sv-stat-value">{stat.value}</span>
            <span className="sv-stat-label">{stat.label}</span>
          </div>
        ))}
      </section>

      {/* ── SIDEBAR + CONTENT ── */}
      <div className="sv-layout">

        {/* Sidebar */}
        <aside className="sv-sidebar">
          <div className="sv-sidebar-label">Our Services</div>
          {loadingServices ? (
            <div className="sv-sidebar-loading">
              <i className="fa-solid fa-spinner fa-spin"></i>
            </div>
          ) : (
            SERVICES.map((service, i) => (
              <button
                key={service.id || i}
                className={`sv-sidebar-item${activeIdx === i ? " sv-sidebar-item--active" : ""}`}
                onClick={() => setActiveIdx(i)}
              >
                <span className="sv-sidebar-item-icon">
                  <i className={service.icon}></i>
                </span>
                <span className="sv-sidebar-item-name">{service.name}</span>
                <span className="sv-sidebar-item-arrow">→</span>
              </button>
            ))
          )}

          <div className="sv-sidebar-divider"></div>

          {/* CTA card */}
          <div className="sv-sidebar-cta">
            <div className="sv-sidebar-cta-title">Need help choosing?</div>
            <div className="sv-sidebar-cta-sub">
              Tell us your goal and we'll recommend the right service for you.
            </div>
            <NavLink to="/contact" className="sv-sidebar-cta-btn">
              Get a Free Consultation
            </NavLink>
          </div>
        </aside>

        {/* Content */}
        <main className="sv-content">
          {active ? (
            <>
              {/* Visual pictorial */}
              <ServiceVisual index={activeIdx} />

              {/* Service tag */}
              <span className="sv-content-tag">{active.tag}</span>

              {/* Title + desc */}
              <h2 className="sv-content-title">{active.name}</h2>
              <p className="sv-content-desc">{active.description}</p>

              {/* Features grid */}
              {active.features.length > 0 && (
                <div className="sv-features-grid">
                  {active.features.map((f, i) => (
                    <div className="sv-feature-item" key={i}>
                      <div className="sv-feature-check">
                        <i className="fa-solid fa-check"></i>
                      </div>
                      <div>
                        <div className="sv-feature-name">{f.name}</div>
                        <div className="sv-feature-sub">{f.sub}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Divider */}
              <div className="sv-content-divider"></div>

              {/* Process strip */}
              <div className="sv-process-strip">
                <span className="sv-strip-label">How We Deliver</span>
                <div className="sv-process-row">
                  {[
                    { n: "01", title: "Discover", desc: "Goals, users & constraints" },
                    { n: "02", title: "Design",   desc: "Architecture & wireframes" },
                    { n: "03", title: "Build",    desc: "Agile sprints with demos" },
                    { n: "04", title: "Launch",   desc: "Deploy, monitor & support" },
                  ].map((step, i, arr) => (
                    <div className="sv-process-step" key={i}>
                      <div className="sv-process-step-num">{step.n}</div>
                      <div className="sv-process-step-title">{step.title}</div>
                      <div className="sv-process-step-desc">{step.desc}</div>
                      {i < arr.length - 1 && <div className="sv-process-arrow">→</div>}
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div className="sv-content-loading">
              <i className="fa-solid fa-spinner fa-spin"></i>
            </div>
          )}
        </main>
      </div>

      {/* ── PRICING ── */}
      <Pricing />

      {/* ── CTA ── */}
      <section className="services-cta-section">
        <div className="services-cta-inner">
          <div className="sv-cta-orb"></div>
          <span className="sv-section-eyebrow">{t("cta.eyebrow")}</span>
          <h2 className="services-cta-title">{t("cta.title")}</h2>
          <p className="services-cta-sub">{t("cta.sub")}</p>
          <NavLink to="/contact" className="btn-primary btn-primary--large">
            <i className="fa-solid fa-paper-plane"></i> {t("nav.letsTalk")}
          </NavLink>
        </div>
      </section>

    </div>
  );
};

export default Services;